<template>
  <div
    style="
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: white;
      height: 100%;
    "
  >
    <div class="t_sp_box">
      <div class="t_sp_title">贵单位注册信息审核未通过，请重新注册！</div>
      <div class="t_backinfobox">
        <div class="t_backinfo">
          <div>审批单位：</div>
          <div class="t_back_con">{{ failmsg.dqbmLabel }}</div>
        </div>
        <div class="t_backinfo">
          <div>审批人：</div>
          <div class="t_back_con">{{ failmsg.sjsprLabel }}</div>
        </div>
        <!-- <div class="t_backinfo">
                    <div>审批人：</div>
                    <div class="t_back_con">{{failmsg.sjsprLabel}}</div>
                  </div> -->
        <div class="t_backinfo">
          <div>审批时间：</div>
          <div class="t_back_con">{{ failmsg.spsj }}</div>
        </div>
        <!-- <div class="t_backinfo">
                    <div>联系方式：</div>
                    <div class="t_back_con">{{failmsg.sjsprTel}}</div>
                  </div> -->
      </div>
      <div style="width: 1000px; margin-top: 50px">
        <div style="margin-bottom: 25px">未通过原因:</div>
        <div class="t_fail_msg">{{ failmsg.spyj }}</div>
      </div>
      <el-button
        v-preventReClick
        style="background-color: #4170ff; color: white; margin-top: 50px"
        @click="back"
      >重新申请</el-button>
    </div>
  </div>
</template>

<script>
// 获取接口地址
import { qyxxBtg } from '@/assets/js/common.js'

export default {
  name: 'Spfail',
  components: {
    // Header,
  },
  data() {
    return {
      failmsg: []
    }
  },
  created: function() {
    this.fail()
  },
  methods: {
    back() {
      this.$router.push('/Rwsq')
    },
    fail() {
      qyxxBtg().then((e) => {
        this.failmsg = e.data.data
      })
    }
  }
}
</script>

<style scoped>
.t_sp_box {
  display: flex;
  align-items: center;
  /* justify-content: center; */
  flex-direction: column;
  width: 1000px;
}
.t_sp_title {
  font-size: 20px;
  text-align: center;
  margin-bottom: 50px;
}
.t_backinfo {
  display: flex;
  font-size: 15px;
  align-items: center;
  margin-bottom: 10px;
  margin-right: 40px;
}
.t_back_con {
  background-color: #f7f7f7;
  padding: 10px 15px;
  border-radius: 5px;
}
.t_backinfobox {
  display: flex;
  flex-wrap: wrap;
}
.t_fail_msg {
  background-color: #f7f7f7;
  padding: 30px;
  border-radius: 5px;
}
</style>
